import React, { useEffect, useState } from 'react'
import { GetAllowedForReserve_ObjectInstance_Api } from '../../API/ObjectInstanceApi';
import { Col, Row } from 'antd';
import { layoutStyle, headerStyle, contentStyle, footerStyle, rowStyle, returnButton } from '../../assets/styles/stylesMain'
import { ObjectFieldsComponent } from './ObjectFieldsComponent';
import { SetReserveObjectInstance_Reserve_Api } from '../../API/ReserveApi';
// ====================================================================== 
export const ObjectsComponent = ({ setLoading, showMessage, reserve, onObjectChanged }) => {
    // ====================================================================== 
    const [objectInstances, setObjectInstances] = useState([]);
    const [hasError, setHasError] = useState(false);
    // ====================================================================== 
    useEffect(() => {
        if (reserve) {
            loadObjectInstances();
        } else {
            // اگر reserve وجود نداشته باشد
            showMessage("مراحل رزرو به درستی انجام نشده است. لطفاً از ابتدا فرآیند را شروع کنید.", "error");
            setHasError(true);
        }
    }, [reserve]);
    // ======================================================================
    const loadObjectInstances = async () => {
        setLoading(true);
        setHasError(false);
        try {
            const data = await GetAllowedForReserve_ObjectInstance_Api(reserve.id);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                const instances = data.messageData.data || [];
                setObjectInstances(instances);
                
                // اگر هیچ اتاقی موجود نباشد
                if (instances.length === 0) {
                    showMessage("اتاقی برای رزرو در بازه زمانی انتخاب شده وجود ندارد. لطفاً بازه زمانی دیگری را امتحان کنید.", "info");
                }
            }
            else {
                showMessage(data.message, "error");
                setHasError(true);
            }
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error");
            setHasError(true);
        }
    }
    // ======================================================================
    const setReserveObjectInstance = async (objectInstanceId) => {
        setLoading(true);
        try {
            var params =
            {
                "reserveId": reserve.id,
                "objectInstanceId": objectInstanceId
            };
            const data = await SetReserveObjectInstance_Reserve_Api(params);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                if (onObjectChanged) onObjectChanged();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    
    // اگر reserve وجود نداشته باشد
    if (!reserve) {
        return (
            <div className='container' style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{ 
                    backgroundColor: '#fff3cd', 
                    border: '1px solid #ffeaa7', 
                    padding: '15px', 
                    borderRadius: '5px',
                    color: '#856404'
                }}>
                    <h3>خطا در فرآیند رزرو</h3>
                    <p>مراحل قبلی به درستی انجام نشده است و امکان ادامه وجود ندارد.</p>
                    <p>لطفاً از ابتدا فرآیند رزرو را شروع کنید.</p>
                </div>
            </div>
        );
    }
    
    // اگر در حال لود کردن باشد
    if (objectInstances === undefined && !hasError) {
        return (
            <div className='container' style={{ textAlign: 'center', padding: '20px' }}>
                <p>در حال دریافت اطلاعات اتاق‌ها...</p>
            </div>
        );
    }
    
    // اگر خطایی رخ داده باشد
    if (hasError) {
        return (
            <div className='container' style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{ 
                    backgroundColor: '#f8d7da', 
                    border: '1px solid #f5c6cb', 
                    padding: '15px', 
                    borderRadius: '5px',
                    color: '#721c24'
                }}>
                    <h3>خطا در دریافت اطلاعات</h3>
                    <p>مشکلی در دریافت اطلاعات اتاق‌ها رخ داده است.</p>
                </div>
            </div>
        );
    }
    
    // اگر هیچ اتاقی موجود نباشد
    if (objectInstances.length === 0) {
        return (
            <div className='container' style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{ 
                    backgroundColor: '#d1ecf1', 
                    border: '1px solid #bee5eb', 
                    padding: '15px', 
                    borderRadius: '5px',
                    color: '#0c5460'
                }}>
                    <h3>اتاقی یافت نشد</h3>
                    <p>متأسفانه هیچ اتاقی برای رزرو در بازه زمانی انتخاب شده و متناسب با ظرفیت نفرات ثبت شده وجود ندارد.</p>
                    <p>لطفاً بازه زمانی دیگری را امتحان کنید.</p>
                </div>
            </div>
        );
    }
    
    // نمایش لیست اتاق‌ها
    return (
        <div className='container'>
            <Row>
                {objectInstances.map((objectInstance, key) =>
                    <Col
                        xs={24} sm={24} md={12} lg={6} xl={6}
                        onClick={() => { setReserveObjectInstance(objectInstance.id) }}
                        key={key}
                        style={{ padding: "5px" }}>
                        <div
                            className={reserve.objectInstanceId == objectInstance.id ? 'btn-info' : 'btn-light'}
                            style={{ padding: '5px', cursor: 'pointer', border: "1px solid #cdcdcd", textAlign: "center" }}>
                            <h3>{objectInstance.title}</h3>
                            {reserve.period.isLottery ? <h4 style={{color:'orange'}}>تعداد رزرو تا این لحظه: {objectInstance?.reserveCount }</h4> : <></>}
                            <ObjectFieldsComponent
                                setLoading={setLoading}
                                showMessage={showMessage}
                                objectInstanceId={objectInstance.id}
                            />
                        </div>
                    </Col>
                )}
            </Row>
        </div>
    );
}





/*import React, { useEffect, useState } from 'react'
import { GetAllowedForReserve_ObjectInstance_Api } from '../../API/ObjectInstanceApi';
import { Col, Row } from 'antd';
import { layoutStyle, headerStyle, contentStyle, footerStyle, rowStyle, returnButton } from '../../assets/styles/stylesMain'
import { ObjectFieldsComponent } from './ObjectFieldsComponent';
import { SetReserveObjectInstance_Reserve_Api } from '../../API/ReserveApi';
// ====================================================================== 
export const ObjectsComponent = ({ setLoading, showMessage, reserve, onObjectChanged }) => {
    // ====================================================================== 
    const [objectInstances, setObjectInstances] = useState();
    // ====================================================================== 
    useEffect(() => {
        if (reserve)
            loadObjectInstances();
    }, [reserve]);
    // ======================================================================
    const loadObjectInstances = async () => {
        setLoading(true);
        try {
            const data = await GetAllowedForReserve_ObjectInstance_Api(reserve.id);
            setLoading(false);
            if (data.messageStatus == "Successful")
                setObjectInstances(data.messageData.data);
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const setReserveObjectInstance = async (objectInstanceId) => {
        setLoading(true);
        try {
            var params =
            {
                "reserveId": reserve.id,
                "objectInstanceId": objectInstanceId
            };
            const data = await SetReserveObjectInstance_Reserve_Api(params);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                if (onObjectChanged) onObjectChanged();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    return (

        (reserve && objectInstances) ?


            objectInstances.length > 0 ?
                <div className='container'>
                    <Row  >
                        {objectInstances.map((objectInstance, key) =>
                            <Col
                                xs={24} sm={24} md={12} lg={6} xl={6}
                                onClick={() => { setReserveObjectInstance(objectInstance.id) }}
                                key={key}

                                style={{ padding: "5px" }}>
                                <div
                                    className={reserve.objectInstanceId == objectInstance.id ? 'btn-info' : 'btn-light'}

                                    style={{ padding: '5px', cursor: 'pointer', border: "1px solid #cdcdcd", textAlign: "center" }}>
                                    <h3>{objectInstance.title}</h3>
                                    {reserve.period.isLottery ? <h4 style={{color:'orange'}}>تعداد رزرو تا این لحظه: {objectInstance.reserveCount}</h4> : <></>}
                                    <ObjectFieldsComponent
                                        setLoading={setLoading}
                                        showMessage={showMessage}
                                        objectInstanceId={objectInstance.id}
                                    />
                                </div>
                            </Col>
                        )}
                    </Row>
                </div> :
                <></>
            : <></>
    )
}
    */
